import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export default {
    namespaced: true,
    state: {
        files: [],
        iframeUrl: undefined,
        faq: undefined,
        acceptedTos: false,
    },
    actions,
    mutations,
    getters,
}
